import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import TransportService from '../../services/TransportService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';
import StringUtils from '../../utils/StringUtils';

class TransportListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new TransportService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
        };
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            name: criteria.name,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            name: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'transport.listTitle';
    }
    getCriteriaName() {
        return 'transport-list-sc';
    }

    getContainerListName() {
        return 'transport-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='name-sc'
                        name='name'
                        label={t('transport.name')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.name}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('transport.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'name', header: t('transport.name'), sortable: false},
            {
                field: 'pointsPerActivity',
                header: t('transport.pointsPerActivity'),
                sortable: false,
                float: 'right',
                body: this.formatPointsPerActivity.bind(this),
            },
            {field: 'action', header: t('global.action'), body: this.actionTemplate, float: 'center'},
        ];
    }
    formatPointsPerActivity(rowData, obj) {
        if (rowData.type === 'CARSHARING') {
            const pointsPerActivity = StringUtils.isBlank(rowData.pointsPerActivity) ? 0 : rowData.pointsPerActivity;
            const teamMemberPointsPerActivity = StringUtils.isBlank(rowData.teamMemberPointsPerActivity) ? 0 : rowData.teamMemberPointsPerActivity;
            return `${pointsPerActivity} - ${teamMemberPointsPerActivity}`;
        }
        if (!StringUtils.isBlank(rowData.pointsPerActivity)) {
            return rowData.pointsPerActivity;
        }
        return '';
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
    
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }
    breadCrumbItems() {
        return [{name: t('transport.listName'), url: '/transport-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

TransportListContainer.defaultProps = {
    detailUrl: '/transport/details',
    newUrl: '/transport/create',
    editUrl: '/transport/edit',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

TransportListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(TransportListContainer));
